var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136.685,
    height: 136.685,
    viewBox: "0 0 136.685 136.685",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dollar-ico",
    transform: "translate(-284.6 -70.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M352.94,72.551A65.843,65.843,0,1,0,418.785,138.4,65.917,65.917,0,0,0,352.94,72.551Zm0,120.771A54.93,54.93,0,1,1,407.873,138.4,54.994,54.994,0,0,1,352.94,193.322Z",
    transform: "translate(0 0)",
    fill: "#e9eff4",
    stroke: "#fff",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M384.925,130.916c.025,0,.048.013.073.013s.043-.013.068-.013a9.84,9.84,0,0,1,9.757,9.824,5.455,5.455,0,1,0,10.91,0,20.707,20.707,0,0,0-15.281-19.919v-.37a5.455,5.455,0,1,0-10.91,0v.365a20.7,20.7,0,0,0,5.448,40.673,9.83,9.83,0,1,1-9.83,9.83,5.455,5.455,0,1,0-10.91,0,20.715,20.715,0,0,0,15.295,19.926v.386a5.455,5.455,0,1,0,10.91,0v-.39a20.69,20.69,0,0,0-5.464-40.661,9.831,9.831,0,0,1-.066-19.662Z",
    transform: "translate(-32.05 -17.633)",
    fill: "#e9eff4",
    stroke: "#fff",
    strokeWidth: 5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.542f2de9944e3991e5b98485a73157e9.svg";
export { ForwardRef as ReactComponent };